<template>
	<div class="rtc-private-acceptor">
		<head-image :id="friend.id" :name="friend.nickName" :url="friend.headImage" :size="100"
			:isShowUserInfo="false"></head-image>
		<div class="acceptor-text">
			{{ tip }}
		</div>
		<div class="countdown-tip">未接听将于 {{ countdownText }} 后自动取消</div>
		<div class="btn-group">
			<div class="icon iconfont icon-phone-accept accept" @click="$emit('accept')" title="接受"></div>
			<div class="icon iconfont icon-phone-reject reject" @click="$emit('reject')" title="拒绝"></div>
		</div>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

export default {
	name: "rtcPrivateAcceptor",
	components: {
		HeadImage
	},
	data() {
		return {}
	},
	props: {
		mode: {
			type: String
		},
		friend: {
			type: Object
		},
		countdown: {
			type: Number,
			default: 90
		}
	},
	computed: {
		tip() {
			let modeText = this.mode == "video" ? "视频" : "语音"
			return `${this.friend.nickName} 请求和您进行${modeText}通话...`
		},
		countdownText() {
			const totalSeconds = Math.max(0, Math.floor(Number(this.countdown) || 0));
			const minutes = Math.floor(totalSeconds / 60);
			const seconds = totalSeconds % 60;
			return minutes > 0 ? `${minutes}分${seconds}秒` : `${seconds}秒`;
		}
	}
}
</script>

<style scoped lang="scss">
.rtc-private-acceptor {
	position: fixed;
	display: flex;
	flex-direction: column;
	align-items: center;
	right: 24px;
	bottom: 24px;
	width: 250px;
	height: 250px;
	padding: 20px;
	background-color: #fff;
	box-shadow: var(--im-box-shadow-dark);
	border-radius: 4px;
	z-index: 4000;

	.acceptor-text {
		padding: 10px;
		text-align: center;
		font-size: 16px;
	}

	.countdown-tip {
		text-align: center;
		color: #909399;
		font-size: 12px;
	}

	.btn-group {
		display: flex;
		justify-content: space-around;
		margin-top: 20px;
		width: 100%;

		.icon {
			font-size: 60px;
			cursor: pointer;
			border-radius: 50%;

			&.accept {
				color: #45c854;
				animation: anim 2s ease-in infinite, vibration 2s ease-in infinite;

				@keyframes anim {
					0% {
						box-shadow: 0 1px 0 4px #ffffff;
					}

					10% {
						box-shadow: 0 1px 0 8px rgba(69, 200, 84, 0.45);
					}

					25% {
						box-shadow: 0 1px 0 12px rgba(69, 200, 84, 0.32), 0 1px 0 16px rgba(122, 226, 132, 0.24);
					}

					50% {
						box-shadow: 0 2px 5px 10px rgba(69, 200, 84, 0.22), 0 2px 5px 23px rgba(248, 248, 255, 1);
					}
				}

				@keyframes vibration {
					0% {
						transform: rotate(0deg);
					}

					25% {
						transform: rotate(20deg);
					}

					50% {
						transform: rotate(0deg);
					}

					75% {
						transform: rotate(-15deg);
					}

					100% {
						transform: rotate(0deg);
					}
				}

			}

			&.reject {
				color: red;
			}
		}
	}
}
</style>
